import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';

import { TokenStore } from '@core/services';

export const guestGuard: CanMatchFn = () => {
  const router = inject(Router);
  const tokenStore = inject(TokenStore);

  if (tokenStore.hasAccessToken()) {
    return router.createUrlTree(['/users']);
  }

  return true;
};
